import { BaseService } from "@myhealth-raccoon/services";
import { AutomedPaymentResult } from "./types";

class AutomedService extends BaseService {
    constructor() {
        super('myhealth/cors_api', import.meta.env.VITE_AUTOMED_URL);
    }

    public async PaymentResult(SessionId: string, SST: string) {
        return await this.post<AutomedPaymentResult>('myhealth_payment_result', {
            SessionId, SST
        })
    }
}

export const automedService = new AutomedService();
export * from './types';